import UserPlaceholder from '../../assets/images/user_placeholder.svg';
import { Avatar } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';

const UserIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-user-round"
  >
    <circle cx="12" cy="8" r="5" />
    <path d="M20 21a8 8 0 0 0-16 0" />
  </svg>
);

const Participant = ({ id, image }) => {
  return (
    <Avatar
      className="event-bottom-cover "
      style={{ borderRadius: 4 }}
      shape="square"
      src={image.thumbnailUrl || UserPlaceholder}
      size={36}
      icon={UserIcon}
    />
  );
};

Participant.propTypes = {
  id: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
};

export default Participant;
